import React from 'react';
import { Modal } from 'antd';

import useModal, { IModalPayload } from '@hooks/use-modal';

import Widget from './Widget';
import { Trash } from 'lucide-react';

const PenaltyDeleteModal = () => {
  const [modal, setModal] =
    useModal<IModalPayload<{ ids: string[]; type: string }>>('update-penalty');

  const { ids = [] } = modal?.payload || {};

  const onClose = () => {
    setModal({ isOpen: false, payload: null });
  };

  return (
    <Modal
      destroyOnClose
      centered
      width={640}
      onCancel={onClose}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      footer={null}
      title={
        <>
          <Trash size={14} className={'mr-2'} />
          Delete penalty
        </>
      }
      visible={(modal?.isOpen && modal?.payload?.type === 'delete') || false}
    >
      <Widget ids={ids} onClose={onClose} />
    </Modal>
  );
};

export default PenaltyDeleteModal;
